const lv_funnels_optinmonster_inarticle = '@TODO';

export const MidArticleFunnel = () => (
  <div id="mid-article-funnel-content" style={{ display: 'none' }}>
    {lv_funnels_optinmonster_inarticle}
  </div>
);
